import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mg', 'mmol']

  convertToMmol() {
    const mg = parseFloat(this.mgTarget.value)
    if (!isNaN(mg) && mg > 0) {
      this.mmolTarget.value = (mg / 18).toFixed(2)
    } else {
      this.mmolTarget.value = ''
    }
  }

  convertToMg() {
    const mmol = parseFloat(this.mmolTarget.value)
    if (!isNaN(mmol) && mmol > 0) {
      this.mgTarget.value = Math.round(mmol * 18)
    } else {
      this.mgTarget.value = ''
    }
  }
}
